module.exports = __webpack_public_path__ + "img/8.7eb0e30d.jpg";